import { memo } from 'react';
// @ts-expect-error untyped deps
import UIValidatedUrlFormControl from 'ui-addon-form-validation/Url/UIValidatedUrlFormControl';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import FormattedMessage from 'I18n/components/FormattedMessage';
import useComponentMountMetric from '../metrics/useComponentMountMetric';
import { usePropertyValue } from '../v2/hooks/usePropertyValue';
import TextInputAdapter from '../adapters/TextInput';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultValidationMessage = {
  success: '',
  error: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "customerDataProperties.propertyValidationErrorMessages.invalidUrl"
  })
};
const PropertyInputUrl = props => {
  const {
    onChange,
    inputRef,
    formControlUse
  } = props;
  const transferrableProps = getTransferrableProps(props);
  const value = usePropertyValue();
  useComponentMountMetric('PropertyInputUrl');
  return /*#__PURE__*/_jsx(UIValidatedUrlFormControl, {
    type: "basic",
    requireProtocol: true,
    validationMessage: defaultValidationMessage,
    displayOptimized: formControlUse === 'floating',
    children: /*#__PURE__*/_jsx(TextInputAdapter, Object.assign({}, transferrableProps, {
      value: value || '',
      onChange: onChange,
      inputRef: inputRef
    }))
  });
};
export default /*#__PURE__*/memo(PropertyInputUrl);